import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {
    emptyDatiqGraph,
    IDatiqGraph
} from '../../models';

import { DatiqGraphService } from './services';

@Component({
    selector: 'datiq-graph',
    templateUrl: './datiq-graph.component.html',
    styleUrls: ['./datiq-graph.component.scss'],
})
export class DatiqGraphComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    private _settings: IDatiqGraph;
    @Input()
    settings: IDatiqGraph;

    @ViewChild('graphContainer', { static: true }) graphContainer: ElementRef;

    @Input()
    graphId: string;

    id: string;
    @Output()
    tooltipAppeared: EventEmitter<any> = new EventEmitter<any>();

    constructor(private _service: DatiqGraphService) {}

    ngOnChanges({ settings }: SimpleChanges): void {
        if (
            !this._service.shouldGraphUpdate(
                this.id,
                settings.currentValue,
                settings.previousValue
            )
        )
            return;

        this._service.update(
            this.id,
            this.graphContainer?.nativeElement,
            this.settings
        );
    }

    ngOnInit(): void {
        this.settings = !!this.settings
            ? {
                  ...emptyDatiqGraph,
                  ...this.settings,
              }
            : {
                  ...emptyDatiqGraph,
              };
        this.id = this._service.init();
    }

    ngAfterViewInit(): void {
        this.loadGraph();
    }

    loadGraph(): void {
        this._service.create(
            this.id,
            this.graphContainer?.nativeElement,
            this.settings as IDatiqGraph
        );
    }

    ngOnDestroy(): void {
        this._service.dispose(this.id);
    }
}
